import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    head_title: 'Централизованная база данных подведомственных учреждений Beyim Smart QR',
  },
  kk: {
    head_title: 'Beyim Smart QR қарамағындағы мекемелердің орталықтандырылған дерекқоры',
  }
});
